/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Current_Trip_CodeInputs */

const vi_vehicle_current_trip_code = /** @type {(inputs: Vehicle_Current_Trip_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã chuyến`)
};

/**

* @param {Vehicle_Current_Trip_CodeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_current_trip_code = /** @type {((inputs?: Vehicle_Current_Trip_CodeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Current_Trip_CodeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_current_trip_code(inputs)
});